import { Link } from "react-router-dom";
import { blogImageSrc, COURSE_PLACEHOLDER } from "../api/blogImage";

function CourseCard({
  title,
  thumbnail,
  instructor,
  duration,
  rating,
  price,
  to,
  actionLabel = "Enroll Now",
  badge,
  description,
  includes,
  includeLimit = includes?.length || 0,
  priceFull = false,
  taxNote = "",
  detailTo,
  brochure,
  catalog = false,
  actionClassName = "",
  actionPending = false,
}) {
  const facts = [
    duration ? ["Duration", duration] : null,
    rating ? ["Rating", rating, true] : null,
    price ? ["Price", price] : null,
  ].filter(Boolean);

  return (
    <article className={`learn-card${catalog ? " course-catalog-card" : ""}`}>
      <Link to={detailTo || to} className="learn-card-media">
        <img
          src={thumbnail || blogImageSrc(null, COURSE_PLACEHOLDER)}
          alt=""
          onError={(event) => {
            event.target.onerror = null;
            event.target.src = blogImageSrc(null, COURSE_PLACEHOLDER);
          }}
        />
      </Link>
      <div className="learn-card-body">
        <h3>
          <Link to={detailTo || to}>{title}</Link>
        </h3>
        {catalog || instructor ? (
          <p className="learn-card-instructor">{instructor || "\u00a0"}</p>
        ) : null}
        {badge ? <p className="course-type-badge">{badge}</p> : null}
        {catalog || description ? (
          <p className="course-card-desc">{description || "\u00a0"}</p>
        ) : null}
        {catalog || includes?.length ? (
          <ul className="course-include-list">
            {(includes || []).slice(0, includeLimit).map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        ) : null}
        {catalog ? (
          <div className="course-price-bar">
            <div>
              <span className="course-price-kicker">Course fee</span>
              <strong className="course-price-amount">{price || "Free"}</strong>
            </div>
            {taxNote ? <span className="course-price-chip">{taxNote}</span> : null}
          </div>
        ) : facts.length > 0 ? (
          <dl className={`learn-card-facts${priceFull ? " price-full" : ""}`}>
            {facts.map(([label, value, isRating]) => (
              <div key={label}>
                <dt>{label}</dt>
                <dd className={isRating ? "rating-value" : undefined}>
                  {isRating ? <span aria-hidden="true">★</span> : null} {value}
                </dd>
              </div>
            ))}
          </dl>
        ) : null}
        {catalog ? (
          <p className="course-brochure-slot">
            {brochure ? (
              <a className="course-brochure" href={brochure} target="_blank" rel="noreferrer">
                View brochure
              </a>
            ) : (
              "\u00a0"
            )}
          </p>
        ) : null}
        <div className="course-card-actions">
          {actionPending ? (
            <span className="btn-accent is-pending">{actionLabel}</span>
          ) : (
            <Link to={to} className={actionClassName || "btn-accent"}>
              {actionLabel}
            </Link>
          )}
          {detailTo ? (
            <Link to={detailTo} className="btn-accent course-detail-btn">
              View details
            </Link>
          ) : null}
        </div>
        {!catalog && brochure ? (
          <a className="course-brochure" href={brochure} target="_blank" rel="noreferrer">
            View brochure
          </a>
        ) : null}
      </div>
    </article>
  );
}

export default CourseCard;
